import { createElement, FC, RefObject } from 'react';

import ImageScreen from '../primitive/ImageScreen';
import VideoScreen from '../primitive/VideoScreen';
import PreviewVideoScreen from './PreviewVideoScreen';
interface Props {
  className?: string;
  mimeType: string;
  url?: string | null;
  videoRef?: RefObject<HTMLVideoElement>;
}
const MediaPlayer: FC<Props> = ({ className, mimeType, url, videoRef }) => {
  if (mimeType.startsWith('video/')) {
    return <PreviewVideoScreen src={url} className={className} controls nodownload videoRef={videoRef} />;
  } else if (mimeType.startsWith('image/')) {
    return <ImageScreen src={url!} className={className} />;
  } else if (mimeType.startsWith('audio/')) {
    return <VideoScreen src={url!} className={className} controls nodownload videoRef={videoRef} />;
  } else {
    return null;
  }
};

export default MediaPlayer;
